import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from 'App'
import 'style/global.css'
import 'dayjs/locale/zh-cn'

const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container)

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
